import { render, staticRenderFns } from "./SearchWithholdingPayment.vue?vue&type=template&id=0c2a9bc3&scoped=true"
import script from "./SearchWithholdingPayment.vue?vue&type=script&lang=js"
export * from "./SearchWithholdingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a9bc3",
  null
  
)

export default component.exports